var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.tooltip[_vm.hook]}},[_c('b-form-select',{staticClass:"buff",attrs:{"options":_vm.buffList},model:{value:(_vm.innerValue.args.buffCommand),callback:function ($$v) {_vm.$set(_vm.innerValue.args, "buffCommand", $$v)},expression:"innerValue.args.buffCommand"}}),_c('b-form-select',{staticClass:"buff",attrs:{"options":[
      { value:null, text:'-' },
      { value:'a', text:'灰' },
      { value:'r', text:'赤' },
      { value:'b', text:'青' },
      { value:'y', text:'黄' },
      { value:'s', text:'茶' },
      { value:'g', text:'緑' },
      { value:'w', text:'白' },
      { value:'d', text:'黒' },
      { value:'n', text:'無' }
    ]},model:{value:(_vm.innerValue.args.buffColor),callback:function ($$v) {_vm.$set(_vm.innerValue.args, "buffColor", $$v)},expression:"innerValue.args.buffColor"}}),_c('b-form-select',{staticClass:"buff",attrs:{"options":[
      { value:null, text:'-' },
      { value:'buff-magic', text:'強化魔法' },
      { value:'debuff-magic', text:'弱体魔法' },
      { value:'buff-stance', text:'強化体勢' },
      { value:'debuff-stance', text:'弱体体勢' },
      { value:'buff-physical', text:'強化肉体' },
      { value:'debuff-physical', text:'弱体肉体' },
      { value:'buff-mental', text:'強化精神' },
      { value:'debuff-mental', text:'弱体精神' },
      { value:'debuff-cooltime', text:'CT' } ]},model:{value:(_vm.innerValue.args.buffType),callback:function ($$v) {_vm.$set(_vm.innerValue.args, "buffType", $$v)},expression:"innerValue.args.buffType"}}),_vm._v(" のバフが未付与 "),_c('b-button',{attrs:{"variant":"danger","size":"sm"},on:{"click":function($event){return _vm.$emit('remove')}}},[_c('b-icon',{attrs:{"icon":"x"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }